/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackageCategory } from '../fn/work-package-categories/create-work-package-category';
import { CreateWorkPackageCategory$Params } from '../fn/work-package-categories/create-work-package-category';
import { deleteWorkPackageCategory } from '../fn/work-package-categories/delete-work-package-category';
import { DeleteWorkPackageCategory$Params } from '../fn/work-package-categories/delete-work-package-category';
import { getWorkPackageCategory } from '../fn/work-package-categories/get-work-package-category';
import { GetWorkPackageCategory$Params } from '../fn/work-package-categories/get-work-package-category';
import { listWorkPackageCategories } from '../fn/work-package-categories/list-work-package-categories';
import { ListWorkPackageCategories$Params } from '../fn/work-package-categories/list-work-package-categories';
import { updateWorkPackageCategory } from '../fn/work-package-categories/update-work-package-category';
import { UpdateWorkPackageCategory$Params } from '../fn/work-package-categories/update-work-package-category';
import { WorkPackageCategoryDto } from '../models/work-package-category-dto';
import { WorkPackageCategoryDtoPage } from '../models/work-package-category-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackageCategoriesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageCategories()` */
  static readonly ListWorkPackageCategoriesPath = '/v0/workPackageCategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageCategories$Response(params: ListWorkPackageCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDtoPage>> {
    return listWorkPackageCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageCategories(params: ListWorkPackageCategories$Params, context?: HttpContext): Observable<WorkPackageCategoryDtoPage> {
    return this.listWorkPackageCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageCategoryDtoPage>): WorkPackageCategoryDtoPage => r.body)
    );
  }

  /** Path part for operation `getWorkPackageCategory()` */
  static readonly GetWorkPackageCategoryPath = '/v0/workPackageCategories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackageCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageCategory$Response(params: GetWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
    return getWorkPackageCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackageCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageCategory(params: GetWorkPackageCategory$Params, context?: HttpContext): Observable<WorkPackageCategoryDto> {
    return this.getWorkPackageCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageCategoryDto>): WorkPackageCategoryDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackageCategory()` */
  static readonly UpdateWorkPackageCategoryPath = '/v0/workPackageCategories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackageCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageCategory$Response(params: UpdateWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
    return updateWorkPackageCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackageCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageCategory(params: UpdateWorkPackageCategory$Params, context?: HttpContext): Observable<WorkPackageCategoryDto> {
    return this.updateWorkPackageCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageCategoryDto>): WorkPackageCategoryDto => r.body)
    );
  }

  /** Path part for operation `createWorkPackageCategory()` */
  static readonly CreateWorkPackageCategoryPath = '/v0/workPackageCategories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageCategory$Response(params: CreateWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
    return createWorkPackageCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageCategory(params: CreateWorkPackageCategory$Params, context?: HttpContext): Observable<WorkPackageCategoryDto> {
    return this.createWorkPackageCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageCategoryDto>): WorkPackageCategoryDto => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackageCategory()` */
  static readonly DeleteWorkPackageCategoryPath = '/v0/workPackageCategories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackageCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageCategory$Response(params: DeleteWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackageCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackageCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageCategory(params: DeleteWorkPackageCategory$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackageCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
